export const API_ENDPOINTS = {
    tokenUrl: "api/token/token",
    tokenCheckExpiredUrl: "api/token/GetTokenTimeout",
    tokenExtend: "api/token/ExtendToken2",
    trLogin: "api/Customer/TRLogin",
    trLogout: "api/Customer/trlogout",
    createCustomer: "api/Customer/CreateCustomer",
    getAccountEvents: "api/Customer/GetAccountEvents",
    getAccountTickets: "api/Customer/GetAccountTickets",
    getEvents: "api/Event/Get",
    generateCryptoUrl: "Home/GetCryptoToken",
    getEventTickets: "api/StadiumLayout/SchoolDirect",
    getAddOnEvents: "api/Event/GetAddOnEvents",
    findSchoolTickets: "api/Ticket/FindSchoolTickets",
    reserveSeats: "api/ReserveTicket/ReserveSeatsWeb",
    reserveSeatsSeason: "api/ReserveTicket/ReserveSeatsSeason",
    purchaseSchoolTickets: "api/Purchase/PurchaseSchoolTickets",
    validateUrl: "api/customer/GateValidation",

    genericTokenAPI: "api/Token/GetGenericToken",
    getEventsByAtv: "api/Event/GetEventsByATV",
    getHSSponsorsByAtv: "api/Sponsor/GetSHSponsorsByATV",
    getHSTSponsorEvents: "api/Event/GetSHEvents",
    getSHPackageByID: "api/Event/GetSHPackageByID",

    getSHSponsorsByID: 'api/Sponsor/GetSHSponsorsByID',
    eventDirectUrl: "api/Event/GetSHEventByID",

    // packages
    getPackagesPricing: "api/StadiumLayout/SchoolSeasonDirect",
    findSchoolPackages: "api/SeasonPass/SchoolSeasonPost",

    // customer account
    sponsorsUrl: "api/customer/GetSponsors",
    actionsUrl: 'api/customer/actions',
    updateAccount: "api/Customer/UpdateCustomer",
    changePassword: "api/Customer/changepassword",
    forgotPassword: "api/Customer/ForgotPassword",
    printUrl: "api/customer/pdf",
    displayMobileUrl: "api/customer/DisplayMobile",
    receiptUrl: "api/Receipt/Receipt",
    customerReceiptsUrl: "api/Customer/GetCustomerReceipts",

    // push notifications
    accountNotifications: "api/Notification/GetMessages",
    accountNotificationsCount: "api/Notification/GetMessageCount",
    updateNotification: "api/Notification/UpdateMessage",

    // add to wallet
    addToAppleWallet: "api/ticket/AppleWallet",
    googleWallet: "api/ticket/GoogleWallet",

    // stripe
    createSession: 'api/Stripe/CreateSession',

    // ticket
    reserveSessionSeats: 'api/Ticket/ReserveSessionSeats',

    // transfer
    transferViaText: 'api/Customer/Transfer',
    transferViaEmail: 'api/Customer/Transfer',
    getRecentRecipient: 'api/Customer/GetRecentRecipient',

    // section
    sectionUrl: "api/SectionLayout/GetSectionWithFilter",

    saveInsuranceData: "api/Insurance/SaveData",
    updateConfirmation: "api/Confirmation/UpdateConfirmation",

    // direct links
    directTextTickets: "api/Customer/QuickDisplayMobile",

    // faq
    getFrequentAskedQuestions: "api/Faq/GetFaq",

    // saveCartToken
    saveCartToken: "api/Token/SaveCartToken",

    // getCartToken
    getCartToken: "api/Token/GetCartToken",

    //season section map
    seasonSectionUrl: "api/SectionLayout/GetSectionSeason",

    //get system roles call
    getSystemRoles: "api/SystemAccess/GetSystemRoles"

}

  // serverDomain: "http://trdev01.ticketreturn.com",
  // mptBaseUrl: "https://tss.mtpsoftware.com/TSSTS/Invitation",
  // ,
  // // Tickets / Stadium / Seats related calls
  // stadiumUrl: "api/StadiumLayout/StadiumLayout",
  // stadiumFiltersUrl: "api/StadiumLayout/FilterStadiumLayout",
  // seasonStadium: "api/StadiumLayout/SeasonStadium",

  // seasonDirectUrl: "api/StadiumLayout/SeasonDirect",
  // sectionUrl: "api/SectionLayout/GetSectionWithFilter",
  // reserveSeats: "api/ReserveTicket/ReserveSeatsWeb",
  // reserveSeatsSeason: "api/ReserveTicket/ReserveSeatsSeason",
  // ticketsBestSeats: "api/Ticket/Ticket",
  // seasonBestSeats: "api/SeasonPass/SeasonPostMobile",
  // extendReservedTimer: "api/Ticket/ReserveSessionSeats",
  // printTickets: "api/Ticket/PrintTickets",
  // // Purchase related calls
  // purchaseTickets: "api/Purchase/PurchaseTicketsWeb",
  // purchaseMonthlyPass: "api/Purchase/PurchaseTicketsWeb",
  // purchaseSeasonPass: "api/Purchase/PurchaseTicketsSeason",
  // addToAppleWallet: "api/ticket/AppleWallet",
  // updateConfirmation: "api/Confirmation/UpdateConfirmation",
  // // Monthly pass related calls
  // purchaseSubscription: "api/Ticket/SubscriptionPost",
  // // Events related calls
  // getEvents: "api/Event/Get",
  // getEventsByATV: "api/Event/GetEventsByATV",
  // changeLocation: "api/Event/ChangeLocation",
  // getAddOnEvents: "api/Event/GetAddOnEvents",
  // getSeasonPassesMobile: "api/SeasonPass/GetSeasonPassesMobile",
  // getSubscriptions: "api/Event/GetSubscriptions",
  // saveInsuranceData: "api/Insurance/SaveData",
  // // Account related calls
  // findAccount: "api/Customer/FindAccount",
  // forgotpasswordBySMS: "api/Customer/ForgotPasswordBySMS",
  // forgotPasswordByEmail: "api/Customer/ForgotPassword",
  // securityPhrase: "api/Customer/SecurityPhrase",
  // checkSecurityPhrase: "api/Customer/CheckSecurityPhrase",
  // changePassword: "api/Customer/changepassword",
  // FBLogin: "api/Customer/FBLogin",
  // FBAssociate: "api/Customer/FBAssociate",
  // updateCustomer: "api/Customer/UpdateCustomer",
  // updateCustomerAndPin: "api/Customer/UpdateCustomerAndPin",
  // //createCustomerAndPin: "api/Customer/CustomerAndPin",

  // // Terms & Conditions related calls
  // privacyUrl: "api/termsandconditions/privacypolicy",
  // // Receipt related calls

  // orderDetailsUrl: "api/Receipt/GetOrderDetails",
  // ntiUrl: "api/nti/nti",
  // // PCIPay / Paypal iFrame URL
  // iFrameUrl: "https://qa.pcipay.com/pcipay_cc/AuthorizeFormM.aspx",
  // pcipayUrl: "api/pcipay/pcipay",

  // //Customer related calls




  // sellUrl: 'api/customer/sell',
  // reclaimUrl: 'api/customer/reclaim',
  // claimMonthlyPassUrl: 'api/MonthlyPass',
  // transferUrl: 'api/customer/transfer',
  // fbDisassociateUrl: 'api/customer/fbdisassociate',
  // exchangeUrl: 'api/customer/exchange',
  // donateUrl: 'api/customer/donate',
  // ticketStatusUrl: 'api/customer/TicketStatus',


  // trackingScripts: 'api/tracking/GetTrackingIncludeScript',

  // groupPortalSignIn: 'api/GroupPortal/Signin',
  // groupPortalEvent: 'api/GroupPortal/GetGroupPortalEvent',

  // printTicktesPAH: 'api/ticket/PrintTicketsPAH',
  // reserveBarcodedNti: 'api/NTI/ReserveBarcodedNTI',
  // discount: 'api/Discount/CheckDiscount'



// WEBPACK FOOTER //
// ./src/commons/constants/api-endpoints.ts